import { render, staticRenderFns } from "./CurrentUser.vue?vue&type=template&id=26be13a8&scoped=true"
import script from "./CurrentUser.vue?vue&type=script&lang=js"
export * from "./CurrentUser.vue?vue&type=script&lang=js"
import style0 from "./CurrentUser.vue?vue&type=style&index=0&id=26be13a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26be13a8",
  null
  
)

export default component.exports